import {
  Button,
  Divider,
  InlineGrid,
  Link,
  Text,
  ButtonGroup,
  Icon,
  InlineStack,
  TextField,
  BlockStack,
} from "@shopify/polaris";
import {
  ComposeIcon,
  ExternalIcon,
  RefreshIcon,
  CheckIcon,
  XSmallIcon,
} from "@shopify/polaris-icons";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
// import { ComposeIcon, ExternalIcon, RefreshIcon } from "@shopify/polaris-icons";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";

const BasicDetails = ({ product }) => {
  console.log("======= Product Detials =======", product);
  const location = useLocation();
  const [data, setData] = useState({
    productTitle: "",
    category: "",
    description: "",
    productTitleEditing: false,
    categoryEditing: false,
    descriptionEditing: false,
  });

  const productDataMapping = {
    productTitle: "product",
    category: "category",
    description: "description",
  };

  const handleProductSync = async () => {
    const urlParams = new URLSearchParams(location.search);
    const paramValue = urlParams.get("shop");
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/shopify/sync_product_data?shop=${paramValue}`;

    if (paramValue === null) {
      console.log("Shop not found in URL");
      return;
    }

    const newData = {
      id: product?.id,
      title: data.productTitle,
      description: data.description,
    };

    console.log("newData", newData);

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        data: newData,
      }),
    };

    try {
      const response = await fetch(apiUrl, requestOptions);
      console.log("response", response);
      const data = await response.json();
      if (data.status) {
        console.log("Product updated successfully", data);
        alert("Product updated successfully");
      } else {
        alert(data?.message || "Product update failed");
        console.log("Product update failed", data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    setData({
      productTitle: product?.product || "",
      category: product?.category || "",
      description: product?.description || "",
      productTitleEditing: false,
      categoryEditing: false,
      descriptionEditing: false,
    });
  }, [product]);

  const handleEdit = (field, type = "") => {
    const newData = {
      ...data,
      [`${field}Editing`]: !data[`${field}Editing`],
    };

    if (type === "cross") {
      newData[field] = product[productDataMapping[field]];
    }

    setData(newData);
  };

  const handleSave = (field) => {
    setData((prevData) => ({
      ...prevData,
      [`${field}Editing`]: false,
    }));
    // Save the data to the database
  };

  const handleEditProduct = () => {
    const productId = product?.id?.split("/").pop() || "";
    // remove .myshopify.com from the store name
    const storeName = product?.vendor?.split(".myshopify.com")[0] || "";
    const shopifyUrl = `https://admin.shopify.com/store/${storeName}/products/${productId}`;

    window.open(shopifyUrl, "_blank");
  };

  const handleChange = useCallback((value, id) => {
    setData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  }, []);

  const handleDescriptionChange = useCallback((value) => {
    setData((prevData) => ({
      ...prevData,
      description: value,
    }));
  }, []);

  return (
    <>
      <InlineGrid columns={["oneThird", "twoThirds"]}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            rowGap: "15px",
            paddingLeft: "30px",
            paddingTop: "20px",
            paddingBottom: "20px",
            width: "25vw",
          }}
        >
          <Text variant="headingLg" fontWeight="semibold">
            Basic Details
          </Text>
          <Text as="p">
            You can edit this product’s details in your Shopify admin.
          </Text>
          <ButtonGroup>
            <Button
              variant="primary"
              icon={ExternalIcon}
              onClick={handleEditProduct}
            >
              Edit Product
            </Button>
            <Button
              onClick={handleProductSync}
              variant="primary"
              icon={RefreshIcon}
            >
              Sync from Shopify
            </Button>
          </ButtonGroup>
        </div>
        <div
          style={{
            paddingTop: "20px",
            width: "50vw",
            paddingBottom: "20px",
            maxWidth: "60vw",
          }}
        >
          <BlockStack gap="500">
            <InlineGrid
              gap={400}
              columns={["oneThird", "twoThirds"]}
              alignItems="center"
            >
              <Text as="p" alignment="end">
                Product Group ID
              </Text>
              <Text>{product?.id?.split("/").pop() || ""}</Text>
            </InlineGrid>
            <InlineGrid
              gap={400}
              columns={["oneThird", "twoThirds"]}
              alignItems="center"
            >
              <Text as="p" alignment="end">
                Product Title
              </Text>
              <InlineStack align="space-between" blockAlign="center">
                <InlineStack align="center">
                  {data?.productTitleEditing ? (
                    <>
                      <TextField
                        value={data?.productTitle || ""} //{product?.product ||""}
                        onChange={handleChange}
                        // onBlur={handleProductTitleBlur}
                        id="productTitle"
                        autoComplete="off"
                        showCharacterCount
                        autoFocus
                      />
                      <div style={{ paddingLeft: "5px" }}>
                        <InlineStack align="space-around" blockAlign="center">
                          <Button
                            variant="plain"
                            // onClick={handleProductTitleBlur}
                            onClick={() => handleSave("productTitle")}
                          >
                            <InlineStack align="center">
                              <Icon source={CheckIcon} tone="success" />
                            </InlineStack>
                          </Button>
                          <Button
                            variant="plain"
                            tone="critical"
                            onClick={() => handleEdit("productTitle", "cross")}
                          >
                            <InlineStack align="center">
                              <Icon source={XSmallIcon} tone="critical" />
                            </InlineStack>
                          </Button>
                        </InlineStack>
                      </div>
                    </>
                  ) : (
                    <Button
                      variant="plain"
                      onClick={() => handleEdit("productTitle")}
                    >
                      <InlineStack align="space-between" blockAlign="center">
                        <InlineStack align="center">
                          <Text variant="bodyMd">
                            {data?.productTitle || ""}
                          </Text>
                          <Icon source={ComposeIcon} />
                        </InlineStack>
                      </InlineStack>
                    </Button>
                  )}
                </InlineStack>
              </InlineStack>
            </InlineGrid>
            <InlineGrid
              gap={400}
              columns={["oneThird", "twoThirds"]}
              alignItems="center"
            >
              <Text as="p" alignment="end">
                Description
              </Text>
              <InlineStack align="space-between" blockAlign="center">
                <InlineStack align="center">
                  {data?.descriptionEditing ? (
                    <>
                      <ReactQuill
                        id="description"
                        theme="snow"
                        value={data?.description || ""}
                        onChange={handleDescriptionChange}
                        style={{ width: "25vw", maxWidth: "40vw" }}
                      />
                      <div style={{ paddingLeft: "5px" }}>
                        <InlineStack align="space-around" blockAlign="center">
                          <Button
                            variant="plain"
                            onClick={() => handleSave("description")}
                          >
                            <InlineStack align="center">
                              <Icon source={CheckIcon} tone="success" />
                            </InlineStack>
                          </Button>
                          <Button
                            variant="plain"
                            tone="critical"
                            onClick={() => handleEdit("description", "cross")}
                          >
                            <InlineStack align="center">
                              <Icon source={XSmallIcon} tone="critical" />
                            </InlineStack>
                          </Button>
                        </InlineStack>
                      </div>
                    </>
                  ) : (
                    <Button
                      variant="plain"
                      onClick={() => handleEdit("description")}
                    >
                      <InlineStack align="space-between" blockAlign="center">
                        <InlineStack align="center">
                          <Text variant="bodyMd">
                            {data?.description || ""}
                          </Text>
                          <Icon source={ComposeIcon} />
                        </InlineStack>
                      </InlineStack>
                    </Button>
                  )}
                </InlineStack>
              </InlineStack>
            </InlineGrid>
            <InlineGrid
              gap={400}
              columns={["oneThird", "twoThirds"]}
              alignItems="center"
            >
              <Text as="p" alignment="end">
                Product Type
              </Text>
              <InlineStack align="space-between" blockAlign="center">
                <InlineStack align="center">
                  {data?.categoryEditing ? (
                    <>
                      <TextField
                        id="category"
                        value={data?.category} //{product?.category||""}
                        onChange={handleChange}
                        // onBlur={handleProductTypeBlur}
                        autoComplete="off"
                        autoFocus
                      />
                      <div style={{ paddingLeft: "5px" }}>
                        <InlineStack align="space-around" blockAlign="center">
                          <Button
                            variant="plain"
                            onClick={() => handleSave("category")}
                          >
                            <InlineStack align="center">
                              <Icon source={CheckIcon} tone="success" />
                            </InlineStack>
                          </Button>
                          <Button
                            variant="plain"
                            tone="critical"
                            onClick={() => handleEdit("category", "cross")}
                          >
                            <InlineStack align="center">
                              <Icon source={XSmallIcon} tone="critical" />
                            </InlineStack>
                          </Button>
                        </InlineStack>
                      </div>
                    </>
                  ) : (
                    <Button
                      variant="plain"
                      onClick={() => handleEdit("category")}
                    >
                      <InlineStack align="space-between" blockAlign="center">
                        <InlineStack align="center">
                          <Text variant="bodyMd">{data?.category || ""}</Text>
                          <Icon source={ComposeIcon} />
                        </InlineStack>
                      </InlineStack>
                    </Button>
                  )}
                </InlineStack>
              </InlineStack>
            </InlineGrid>
            <InlineGrid
              gap={400}
              columns={["oneThird", "twoThirds"]}
              alignItems="center"
            >
              <Text as="p" alignment="end">
                Vendor (Brand)
              </Text>
              <Text>{product?.vendor || ""}</Text>
            </InlineGrid>
          </BlockStack>
        </div>
      </InlineGrid>
      {/* <InlineGrid columns={["oneThird", "twoThirds"]}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            rowGap: "15px",
            paddingLeft: "30px",
            paddingTop: "20px",
            paddingBottom: "20px",
            width: "25vw",
          }}
        >
          <Text variant="headingLg" fontWeight="semibold">
            Basic Details
          </Text>
          <Text as="p">
            You can edit this product’s details in your Shopify admin.
          </Text>
          <ButtonGroup>
            <Button variant="primary" icon={ExternalIcon}>
              Edit Product
            </Button>
            <Button variant="primary" icon={RefreshIcon}>
              Sync from Shopify
            </Button>
          </ButtonGroup>
        </div>
        <div
          style={{ paddingTop: "20px", width: "50vw", paddingBottom: "20px" }}
        >
          <InlineGrid
            gap={100}
            columns={["oneThird", "twoThirds"]}
            alignItems="center"
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "end",
                width: "15vw",
                rowGap: "5px",
              }}
            >
              <Text as="p">Product Group ID</Text>
              <Text as="p">Product Title</Text>
              <Text as="p">Description</Text>
              <Text as="p">Product Type</Text>
              <Text as="p">Vendor (Brand)</Text>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                width: "20vw",
                rowGap: "5px",
              }}
            >
              <Text>{product?.id?.split("/").pop() || ""}</Text>
              <Link removeUnderline url="https://google.com">
                <InlineStack align="space-between" blockAlign="center">
                  <InlineStack align="center">
                    <Text variant="bodyMd">{product?.product || ""}</Text>
                    <Icon source={ComposeIcon} />
                  </InlineStack>
                </InlineStack>
              </Link>

              <Text>
                <Link removeUnderline url="https://google.com">
                  <Icon source={ComposeIcon} />
                </Link>
              </Text>

              <Link removeUnderline url="https://google.com">
                <InlineStack align="space-between" blockAlign="center">
                  <InlineStack align="center">
                    <Text variant="bodyMd">{product?.category || ""}</Text>
                    <Icon source={ComposeIcon} />
                  </InlineStack>
                </InlineStack>
              </Link>

              <Text>{product?.vendor || ""}</Text>
            </div>
          </InlineGrid>
        </div>
      </InlineGrid> */}
      <Divider />
    </>
  );
};

export default BasicDetails;
